import axios from 'axios'

export const mails = {
  actions: {
    async sendForm({ getters, commit }, form) {
      try {
        const response = await axios({
          method: 'POST',
          url: getters.mailEndpoint,
          data: {
            to: 'marketing@lausanne-tourisme.ch',
            template: 'demand',
            locale: 'fr',
            form,
          },
        })

        return response.data
      } catch (err) {
        console.log('err', err)
        commit('setMailsError', 'errors.mails')
      }
    },

    async sendConfirmation({ getters, rootState, commit }, form) {
      try {
        const response = await axios({
          method: 'POST',
          url: getters.mailEndpoint,
          data: {
            to: form.email,
            template: 'confirmation',
            locale: rootState.locale,
            form,
          },
        })

        return response.data
      } catch (err) {
        commit('setMailsWarning', 'warnings.mails')
      }
    },
  },

  getters: {
    mailEndpoint(state, getters, rootState) {
      return `${rootState.apiEndoint}/mails`
    }
  }
}
